import globalStoreGetters from '@constans/store/global/globalStoreGetters';
const getters = {
    [globalStoreGetters.GET_LOADING]: (state) => state.loading,
    [globalStoreGetters.GET_SNACKBAR]: (state) => state.snackbar
};
export default getters;
